import { makeAxiosRequest } from 'utils/apiMethods';

export default {
  getActivePropertiesCoordinates: makeAxiosRequest('/get-active-properties-coordinates', { method: 'get' }, true),
};
